import ManagedListWeb from "./ManagedListWeb";
export default ManagedListWeb;